import React, { useContext, useMemo } from 'react'
import { Modal, ModalBody, ModalHeader } from 'reactstrap'

import { getChatRoom } from '../../redux/slices/chatSlice'
import { SpinnerContext } from '../../context/spinnerContext'
import { useDispatch } from 'react-redux'
import { Link, useNavigate } from 'react-router-dom'
import { errorToast, successToast } from '../../util/Toast/toast'

const StatusModal = ({
  title,
  toggle,
  children,
  isTitle = true,
  size = 'md',
  onClose,
  headerContent = { name: 'Laurence Nathanson', status: 'Cleaning schedule' },
  chatUserId = null,
  clientId = null
  // CheckTimeOver
}) => {
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const { changeLoader } = useContext(SpinnerContext)

  // const OVERDUE = '(Overdue)'

  const statusClasses = useMemo(() => {
    if (headerContent?.status === 'scheduled') {
      return 'success-status'
    } else if (headerContent?.status === 'canceled') {
      return 'status-red'
    } else if (headerContent?.status === 'in progress') {
      return 'in-progress-status'
    } else {
      return 'status-sky'
    }
  }, [headerContent])

  const onHandleViewChat = (userId) => {
    changeLoader(true)
    dispatch(getChatRoom(userId))
      .then(({ payload, error }) => {
        changeLoader(false)
        if (payload?.status === 200) {
          const chatRoom = payload?.data?.data?.chatRoom
          navigate(`/chat/${userId}/room/${chatRoom?.chat_room_id}`)
          successToast(payload?.data?.status_message || 'Success!')
        } else {
          errorToast(payload?.data?.status_message || error?.message)
        }
      })
      .catch(() => {
        changeLoader(false)
      })
  }
  return (
    <Modal size={size} isOpen={true} toggle={toggle} centered className="status-modal">
      {isTitle && (
        <ModalHeader toggle={toggle}>
          <div className="w-100">
            <div className="small_modal_head_div">
              <h6 className="small_modal_title">{title}</h6>
              <div className="show_box show_bg" onClick={() => onHandleViewChat(chatUserId)}>
                <p>
                  View Chat <i className="far fa-comments" style={{ marginLeft: '5px' }}></i>
                </p>
              </div>
            </div>
            <div className="status-close-wrap" onClick={onClose}>
              <i className="fa-regular fa-circle-xmark" />
            </div>
          </div>
        </ModalHeader>
      )}
      <ModalBody>
        {headerContent && (
          <div className="d-inline-flex justify-content-between w-100 sub-header">
            <Link className="links_text" to={`/clients/clientInfo/${clientId}`}>
              {headerContent?.name || 'No Client Yet'}
            </Link>
            <div className={`status ${statusClasses}`}>
              Cleaning {headerContent?.status}{' '}
              {/* {!['canceled cleaner', 'canceled', 'completed']?.includes(headerContent?.status) && CheckTimeOver ? OVERDUE : ''} */}
            </div>
          </div>
        )}

        {children}
      </ModalBody>
    </Modal>
  )
}

export default StatusModal
